<script setup lang="ts">
import { ref } from 'vue';

import { AppImg } from '@libs/ui';

import { useCoreStore } from '../../../../../../core/stores';
import type {
  AccommodationProductCardData,
  AccommodationSegmentContext,
} from '../../../../models';
import AccommodationProductCardContent from '../AccommodationProductCardContent.vue';
import AccommodationCardSelectedFooter from '../AccommodationCardSelectedFooter.vue';
import DateCardTag from '../../DateCardTag.vue';

import MobileProductCardLayout from './MobileProductCardLayout.vue';

interface AccommodationProductCardMobileProps {
  productCardData: AccommodationProductCardData;
  context: AccommodationSegmentContext;
}

const props = defineProps<AccommodationProductCardMobileProps>();

interface AccommodationProductCardMobileEmits {
  (event: 'show-details'): void;
  (event: 'show-rooms'): void;
}

const emit = defineEmits<AccommodationProductCardMobileEmits>();

const coreStore = useCoreStore();

const enableHoverColor = ref<boolean>(false);
</script>

<template>
  <MobileProductCardLayout
    class="accommodation-product-card-mobile"
    @click.stop="emit('show-details')"
  >
    <template #top-section>
      <AppImg
        class="image"
        :src="productCardData.imgSrcs[0] || ''"
        :alt="$t('a11y.hotel_image')"
        @img-load-error="
          (src) =>
            coreStore.handleImageLoadError({
              src: src,
              source: 'accommodation-product-card-mobile-image',
            })
        "
      />
    </template>
    <template #content>
      <AccommodationProductCardContent
        :product-card-content="props.productCardData.productCardContent"
        :context="props.context"
        :print-mode="false"
        @mouse-enter-content="enableHoverColor = true"
        @mouse-leave-content="enableHoverColor = false"
        @show-details="emit('show-details')"
        @show-rooms="emit('show-rooms')"
      />
    </template>
    <template #footer>
      <AccommodationCardSelectedFooter
        :ingredient-index="props.context.ingredientIndex"
      />
    </template>
    <template #top-section-tag>
      <DateCardTag :date="props.productCardData.date" />
    </template>
  </MobileProductCardLayout>
</template>

<style lang="scss" scoped>
.accommodation-product-card-mobile {
  &.experiment {
    position: relative;

    .trash-icon {
      position: absolute;
      top: 0;
      right: 0;
    }
    .image {
      aspect-ratio: 4 / 3;
      max-height: 200px;
    }

    .button-wrapper {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: var(--spacing-16);

      .details {
        @include font-label-m-light;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .image {
    aspect-ratio: 4 / 3;
  }
}
</style>
